export default __webpack_public_path__ + "de8e2eab1950c44c245f94dc7e4f1a54.svg";